import React from "react";
import IconDone from "../Auth/assets/IconDone";
import { FormBtn, FormBtnText } from "./styled";

const FormButton = ({ textBtn, success, onClick, type, disabled }) => {
  return (
    <FormBtn
      disabled={success || disabled ? true : false}
      success={success}
      onClick={onClick}
      type={type}
    >
      {success && <IconDone />}
      <FormBtnText>{success ? "Сохранено" : textBtn}</FormBtnText>
    </FormBtn>
  );
};

export default FormButton;
